import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { selectLegacyBaseUrl } from '~/store';
import { routerHistoryShape, routerMatchShape } from '../helpers/propTypeShapes';
import '../style/engagement.css';
import Admin from './Admin';

class Engagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeComponent: 'comments',
      URL: '',
    };

    this.navigateLowerPanel = this.navigateLowerPanel.bind(this);
    this.navigate = this.navigate.bind(this);
  }

  componentDidMount() {
    const authorized = this.props.checkAuthorization(`engagement/${this.props.match.params.pageName}`);
    if (!authorized) {
      return;
    }

    this.setState({ activeComponent: this.props.match.params.pageName }, () => {
      this.navigate();
    });
  }

  navigate() {
    const { legacyBaseUrl } = this.props;

    if (this.state.activeComponent === 'comments') {
      this.props.history.push('/engagement/comments');
      this.setState({ URL: `${legacyBaseUrl}/comments/index.php` });
    } else if (this.state.activeComponent === 'polls') {
      this.props.history.push('/engagement/polls');
      this.setState({ URL: `${legacyBaseUrl}/polls/index.php` });
    } else if (this.state.activeComponent === 'prompter') {
      this.props.history.push('/engagement/prompter');
      this.setState({ URL: `${legacyBaseUrl}/comments/prompter-manager.php` });
    } else if (this.state.activeComponent === 'graphics') {
      this.props.history.push('/engagement/graphics');
      this.setState({ URL: `${legacyBaseUrl}/tools/overlay-builder/index.php` });
    }
  }

  navigateLowerPanel(event) {
    const { target } = event;
    const activeItem = document.getElementsByClassName('engagement-nav-item active');

    activeItem[0].classList = ['engagement-nav-item'];
    this.setState({ activeComponent: target.className }, () => {
      this.navigate();
      target.parentElement.className += ' active';
    });
  }

  isNavElementActive(className) {
    if (this.state.activeComponent === className) {
      return 'engagement-nav-item active';
    }

    return 'engagement-nav-item';
  }

  render() {
    if (this.state.URL !== '') {
      return (
        <div className="engagement-content">
          <div className="engagement-nav-container">
            <ul className="engagement-nav">
              <li className={this.isNavElementActive('comments')}>
                <button type="button" className="comments" onClick={this.navigateLowerPanel}>
                  COMMENTS
                </button>
              </li>
              <li className={this.isNavElementActive('polls')}>
                <button type="button" className="polls" onClick={this.navigateLowerPanel}>
                  POLLS
                </button>
              </li>
              <li className={this.isNavElementActive('prompter')}>
                <button type="button" className="prompter" onClick={this.navigateLowerPanel}>
                  PROMPTER
                </button>
              </li>
              <li className={this.isNavElementActive('graphics')}>
                <button type="button" className="graphics" onClick={this.navigateLowerPanel}>
                  GRAPHICS
                </button>
              </li>
            </ul>
          </div>
          <Admin
            checkAuthorization={this.props.checkAuthorization}
            iframeSrc={this.state.URL}
            reAuth={this.props.reAuth}
            trackEvent={this.props.trackEvent}
          />
        </div>
      );
    }

    return <div />;
  }
}

const mapStateToProps = (state) => ({ legacyBaseUrl: selectLegacyBaseUrl(state) });
const mapDispatchToProps = {};

Engagement.propTypes = {
  checkAuthorization: PropTypes.func.isRequired,
  history: routerHistoryShape.isRequired,
  match: routerMatchShape.isRequired,
  reAuth: PropTypes.func.isRequired,
  trackEvent: PropTypes.func.isRequired,
  legacyBaseUrl: PropTypes.string.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Engagement);
